import { render, staticRenderFns } from "./chatItem.vue?vue&type=template&id=64a50cc0&"
import script from "./chatItem.vue?vue&type=script&lang=js&"
export * from "./chatItem.vue?vue&type=script&lang=js&"
import style0 from "./chatItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports